import React from "react";
import { VideoPanelWithText } from "./view/VideoPanelWithText";

export const renderRule = {
  match: (item, cmsOption) => item.itemTypeCode === "VideoPanelWithText",
  itemElt: (item, cmsOption) => (
    <VideoPanelWithText item={item} cmsOption={cmsOption} />
  ),
};
